var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "256px",
    viewBox: "0 0 240 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Avataaar/Circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 120,
    cy: 120,
    r: 120
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.19744231e-14,160 L-3.19744231e-14,-1.42108547e-14 L264,-1.42108547e-14 L264,160 L252,160 C252,226.27417 198.27417,280 132,280 C65.72583,280 12,226.27417 12,160 L12,160 L-3.19744231e-14,160 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156.000809,62.1660527 C161.675838,63.1185422 166,68.05429 166,74 L166,88 C166,94.0524166 161.519235,99.0582945 155.693975,99.8813638 C153.627928,119.686472 141.237929,136.421678 124.001014,144.610469 L124,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L76,163 L75.9999836,144.610943 C58.7625487,136.422324 46.3721119,119.686854 44.3051107,99.8809698 C38.480765,99.0582945 34,94.0524166 34,88 L34,74 C34,68.053942 38.3246685,63.1179645 44.0001873,62.1658855 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,30.3476251 C99,42.2107177 113.998461,51.8276544 132.5,51.8276544 C151.001539,51.8276544 166,42.2107177 166,30.3476251 C166,29.9947569 165.98673,29.643876 165.960492,29.2951765 C202.936371,32.3248899 232,63.2942196 232,101.051724 L232,110 L32,110 L32,101.051724 C32,62.952169 61.5925972,31.764336 99.0465686,29.2194474 C99.0151943,29.59473 99,29.9700398 99,30.3476251 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 0,
    y: 0,
    width: 264,
    height: 280
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3139331,151.591294 C86.6469247,164.342684 96.5611,174.701567 108.998986,180.610469 L109.000498,189.610276 C106.639234,190.401998 104.095411,191.063242 101.273548,191.569729 C92.2609618,193.18734 66.9485528,188.041497 55.8287461,179.588187 C54.9804404,178.942941 55.4105393,177.670743 56.4993303,177.596328 C68.2421528,176.792949 74.2106831,165.300379 79.0058562,156.190972 C79.7177834,154.838538 80.404519,153.474084 81.0706626,152.100303 Z M175.125712,166.895604 C175.840743,169.13621 176.874235,171.230121 178.55519,172.685954 C180.17619,174.090053 183.068114,173.745469 185.098621,173.802748 C186.770693,173.850632 188.444623,173.856087 190.114529,173.783655 C190.95366,173.747287 191.327571,174.79771 190.648775,175.281705 C190.518773,175.374442 190.388771,175.462634 190.25846,175.543856 C189.20761,176.198779 188.11838,176.802787 187.008721,177.356184 C184.485135,178.614206 181.821334,179.600077 179.02722,180.090436 C177.110999,180.426483 175.211641,180.489655 173.373193,180.266583 C173.858789,180.986758 174.419512,181.642311 175.071506,182.207788 C176.801481,183.708407 179.887821,183.340135 182.054832,183.401352 C183.839313,183.452528 185.625776,183.458358 187.407944,183.380946 C188.303488,183.342078 188.702535,184.464709 187.978106,184.981974 C187.839364,185.081086 187.700623,185.175341 187.561551,185.262145 C186.440057,185.962089 185.2776,186.607617 184.093342,187.199055 C181.400104,188.543555 178.557223,189.597195 175.57527,190.121262 C170.075488,191.087126 164.705859,189.943766 160.380755,186.413279 C159.163245,185.419467 158.026681,184.286937 156.999075,183.051889 L157.000016,180.610943 C163.870522,177.347119 169.971003,172.725487 174.954684,167.092821 Z M101.441738,25.5998777 C121.403017,20.3995724 135.651446,29.4743102 136.862131,30.2568033 C138.299428,31.1854765 138.85043,30.796545 140.483286,30.4052984 C146.829392,28.8846292 153.741035,28.1960616 160.187893,29.4782789 C166.528383,30.7396605 172.606255,34.0244119 177.74696,37.856181 C187.273882,44.9574883 195.508524,56.4379129 195.90592,68.6796644 C196.081329,74.1868816 195.28885,79.9070851 194.184533,85.2955724 C193.189889,90.1482867 189.869671,93.9714569 188.837367,98.7289227 C186.543239,90.9361007 180.566605,86.1012548 174.148391,81.6588274 L173.290297,81.068604 C173.14694,80.9705459 173.003436,80.8726253 172.859821,80.774814 L171.997078,80.189033 L171.997078,80.189033 L170.701685,79.3123249 C170.270166,79.0200593 169.839245,78.7275106 169.409882,78.4339187 L168.553519,77.8451188 C165.565512,75.7778742 162.685237,73.6346813 160.242068,71.1548033 C162.238626,74.9478777 165.29094,78.1026546 167.294435,81.8328914 C158.047309,76.1675881 149.087576,67.953725 145.262273,57.5379012 C144.554691,62.9359795 142.545911,67.9275978 139.15401,72.2035294 C136.142657,76.0002417 131.572444,80.0744315 126.858864,81.5445 C129.286511,76.0372828 131.361358,70.327001 133.266412,64.6190342 C132.319794,65.8472759 130.345502,68.9483385 128.343376,72.1784629 L127.821108,73.0228852 C125.734771,76.4031126 123.712794,79.7587655 122.891185,81.1086057 C121.234875,83.8298033 119.37772,86.426318 117.383805,88.9120401 C116.450603,90.0751967 115.455298,91.1993278 114.453055,92.302954 C113.869349,92.9458816 113.274082,93.578226 112.665931,94.1980029 C112.555148,94.3107899 112.069596,94.8405621 111.751974,95.1632341 L111.647728,95.2675027 C111.424883,95.4859888 111.359228,95.5142246 111.753871,95.0036468 C109.537639,97.8062025 106.276221,99.9826977 103.44325,102.112561 C100.59079,104.256976 97.4833088,106.08125 94.2522818,107.589351 C87.0932166,110.931649 79.7402436,112.148383 71.9327267,110.752066 L72.147048,110.788105 L72.3284821,110.800693 C73.5480643,110.828501 75.5398586,109.975832 76.6941053,109.626246 L76.8887739,109.570058 C78.6980301,109.07761 80.3625987,108.452872 82.0017312,107.546357 C85.2753717,105.735312 88.3514706,103.576015 91.1778346,101.127995 C88.4707222,102.280238 86.2726593,104.461694 83.513684,105.671152 C81.2270908,106.673576 78.9669245,107.196782 76.4817987,107.437218 C71.0203357,107.966046 64.4865987,106.716901 59.7607964,103.849523 C54.2686121,100.517478 51.2186099,94.7989286 49.7717335,88.7129442 C48.0913088,81.6460323 49.1355043,73.6726057 53.0992189,67.6388757 C53.2336661,69.781637 57.5349852,70.703365 61.0154166,70.1662691 C70.6728211,68.675365 76.4180436,32.1184491 101.441738,25.5998777 Z",
    id: "path-11"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avataaar/Circle",
    transform: "translate(-12.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(12.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Circle-Background",
    fill: "#E6E6E6",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#262E33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD8D-Circle-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83D\\uDD8DColor",
    x: 0,
    y: 0,
    width: 240,
    height: 240
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Avataaar",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(32.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D0C6AC",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.000000, 0.000000)",
    id: "\\uD83C\\uDFA8-Skin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    fill: "#D08B5B",
    x: 0,
    y: 0,
    width: 264,
    height: 244
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,94 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 Z",
    id: "Neck-Shadow",
    fillOpacity: 0.100000001,
    fill: "#000000",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clothes",
    fill: "#E6E6E6",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-8)",
    fill: "#E6E6E6",
    id: "\\u21B3-Color-Fabric"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83D\\uDD8DColor",
    x: 0,
    y: 0,
    width: 264,
    height: 110
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadowy",
    opacity: 0.599999964,
    mask: "url(#mask-8)",
    fill: "#000000",
    fillOpacity: 0.16
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.000000, 4.000000)",
    id: "Hola-\\uD83D\\uDC4B\\uD83C\\uDFFC"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5,
    cy: 27.8476251,
    rx: 39.6351047,
    ry: 26.9138272
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(76.000000, 82.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 52.000000)",
    fillOpacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mouth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,15 C40,22.7319865 46.2680135,29 54,29 L54,29 C61.7319865,29 68,22.7319865 68,15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.000000, 40.000000)",
    fillOpacity: 0.16
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nose"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.418278 21.372583,16 28,16 L28,16 C34.627417,16 40,12.418278 40,8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 8.000000)",
    fillOpacity: 0.599999964
  }, /*#__PURE__*/React.createElement("g", {
    id: "Eye"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 22,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 22,
    r: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillOpacity: 0.599999964,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I-Browse",
    transform: "translate(12.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63024536,11.1585767 C7.54515501,5.64986673 18.2779197,2.56083721 27.5230268,4.83118046 C28.5957248,5.0946055 29.6788665,4.43856013 29.9422916,3.36586212 C30.2057166,2.2931641 29.5496712,1.21002236 28.4769732,0.94659732 C17.7403633,-1.69001789 5.31209962,1.88699832 0.369754639,8.84142326 C-0.270109626,9.74178291 -0.0589363917,10.9903811 0.84142326,11.6302454 C1.74178291,12.2701096 2.9903811,12.0589364 3.63024536,11.1585767 Z",
    id: "Eyebrow"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6302454,11.1585767 C65.545155,5.64986673 76.2779197,2.56083721 85.5230268,4.83118046 C86.5957248,5.0946055 87.6788665,4.43856013 87.9422916,3.36586212 C88.2057166,2.2931641 87.5496712,1.21002236 86.4769732,0.94659732 C75.7403633,-1.69001789 63.3120996,1.88699832 58.3697546,8.84142326 C57.7298904,9.74178291 57.9410636,10.9903811 58.8414233,11.6302454 C59.7417829,12.2701096 60.9903811,12.0589364 61.6302454,11.1585767 Z",
    id: "Eyebrow",
    transform: "translate(73.000154, 6.039198) scale(-1, 1) translate(-73.000154, -6.039198) "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 0.000000)",
    id: "Top"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Hair",
    fill: "#1D2633",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 0.000000)",
    id: "\\u21B3-\\uD83D\\uDC88Hair-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    fill: "#B58143",
    x: 0,
    y: 0,
    width: 264,
    height: 280
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M81.3138259,151.591038 C86.6468244,164.342623 96.5611379,174.701654 108.999214,180.610578 L109.000871,189.610151 C106.639502,190.401928 104.095559,191.063216 101.273548,191.569729 C92.2609618,193.18734 66.9485528,188.041497 55.8287461,179.588187 C54.9804404,178.942941 55.4105393,177.670743 56.4993303,177.596328 C68.2421528,176.792949 74.2106831,165.300379 79.0058562,156.190972 C79.7177834,154.838538 80.404519,153.474084 81.0706626,152.100303 Z M175.125712,166.895604 C175.840743,169.13621 176.874235,171.230121 178.55519,172.685954 C180.17619,174.090053 183.068114,173.745469 185.098621,173.802748 C186.770693,173.850632 188.444623,173.856087 190.114529,173.783655 C190.95366,173.747287 191.327571,174.79771 190.648775,175.281705 C190.518773,175.374442 190.388771,175.462634 190.25846,175.543856 C189.20761,176.198779 188.11838,176.802787 187.008721,177.356184 C184.485135,178.614206 181.821334,179.600077 179.02722,180.090436 C177.111347,180.426422 175.212329,180.489632 173.374193,180.266704 C173.858789,180.986758 174.419512,181.642311 175.071506,182.207788 C176.801481,183.708407 179.887821,183.340135 182.054832,183.401352 C183.839313,183.452528 185.625776,183.458358 187.407944,183.380946 C188.303488,183.342078 188.702535,184.464709 187.978106,184.981974 C187.839364,185.081086 187.700623,185.175341 187.561551,185.262145 C186.440057,185.962089 185.2776,186.607617 184.093342,187.199055 C181.400104,188.543555 178.557223,189.597195 175.57527,190.121262 C170.075488,191.087126 164.705859,189.943766 160.380755,186.413279 C159.163898,185.42 158.0279,184.288152 157.000729,183.053876 L157.000786,180.610578 C163.870978,177.346774 169.971189,172.725277 174.954684,167.092821 Z",
    id: "Shadow",
    fillOpacity: 0.16,
    fill: "#000000"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.7f8a566288fc2f1b94eb475309f9e4d6.svg";
export { ForwardRef as ReactComponent };